import { Button, enumsCashback, formatDate } from '@itarget/shared'
import { Box } from '@material-ui/core'
import { actionsClasses } from './actionsStyles'
import { useTranslation } from './translation'
import { useSelector } from 'react-redux'

export const Actions = (props) => {
  const {
    aceite,
    campanha_id,
    empresa_id,
    data_fim,
    data_inicio,
    handleOpenTerms,
    registerClientCompany,
    clientMembershipCampaign,
  } = props
  const translation = useTranslation()
  const classes = actionsClasses()
  const userPermissions = useSelector((state) => state.fidelity.userPermissions)
  const {
    CAMPAIGN: { ADHERENCE },
  } = enumsCashback
  const hasAdherence =
    (clientMembershipCampaign?.aceite || aceite) === ADHERENCE.ALLOWED
  const today = new Date()
  const startAt = formatDate.parseISO(data_inicio)
  const endAt = formatDate.parseISO(data_fim)
  const available = today >= startAt && today <= endAt
  const handleRegister = () => {
    registerClientCompany?.({
      adherence: ADHERENCE.ALLOWED,
      campaignId: campanha_id,
      companyId: empresa_id,
    })
  }
  return (
    <Box className={classes.actionsContainer}>
      {!hasAdherence && available && (
        <Button
          icon="edit"
          color="primary"
          onClick={handleRegister}
          disabled={userPermissions?.cashWhoCanJoin?.status === 2}
          className={`${classes.actionDefaultStyle} ${classes.actionButtonStyle}`}
        >
          {translation.adherence}
        </Button>
      )}
      <Button
        color="primary"
        variant="outlined"
        onClick={handleOpenTerms}
        className={`${classes.actionDefaultStyle} ${classes.actionButtonStyle}`}
      >
        {translation.viewDetails}
      </Button>
    </Box>
  )
}
